module.exports = __webpack_public_path__ + "img/adult.99466cf4.svg";